jQuery(function ($) {
  const thumbnailSwiper = new Swiper(".js-thumbnail-carousel", {
    loop: false,
    direction: "vertical",
    slidesPerView: 4,
    speed: 1000,
    allowTouchMove: true,
    spaceBetween: 10,
    navigation: {
      prevEl: ".js-thumbnails-carousel-prev",
      nextEl: ".js-thumbnails-carousel-next",
    }
  });

  const productSwiper = new Swiper(".js-product-carousel", {
    slidesPerView: 1,
    centeredSlides: true,
    centerInsufficientSlides: true,
    centeredSlidesBounds: true,
    loop: false,
    slidesOffsetAfter: 20,
    speed: 2000,
    allowTouchMove: true,
    spaceBetween: 0,
    scrollbar: {
      el: ".swiper-scrollbar",
      draggable: false,
    },
    breakpoints: {
      821: {
        centeredSlides: false,
        slidesPerView: 1,
        pagination: false,
        scrollbar: false,
        allowTouchMove: false,
        spaceBetween: 16,
      },
    },
    thumbs: {
      swiper: thumbnailSwiper,
    },
  });

  $(".product-swiper-thumbnail").hover(
    function () {
      $(".js-thumbnail-carousel .swiper-slide-thumb-active").removeClass(
        "swiper-slide-thumb-active"
      );
      $(this).parent().addClass("swiper-slide-thumb-active");

      const index = $(this).parent().index();
      productSwiper.slideTo(index);
    },
    function () {}
  );
});
